var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagramColored = function SvgInstagramColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.824 3.812c-.583 0-1.057.48-1.057 1.072 0 .593.474 1.073 1.057 1.073.584 0 1.057-.48 1.057-1.073 0-.592-.473-1.072-1.057-1.072ZM9.125 12.577c-1.568 0-2.844-1.294-2.844-2.885 0-1.591 1.276-2.886 2.844-2.886 1.568 0 2.844 1.295 2.844 2.886 0 1.59-1.276 2.885-2.844 2.885Zm0-7.39c-2.448 0-4.44 2.021-4.44 4.505 0 2.483 1.992 4.504 4.44 4.504 2.448 0 4.44-2.02 4.44-4.504 0-2.484-1.992-4.505-4.44-4.505Z",
    fill: "#5D5BEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.452 2.268c-2.051 0-3.72 1.693-3.72 3.773v7.303c0 2.08 1.669 3.773 3.72 3.773h7.198c2.051 0 3.72-1.693 3.72-3.773V6.04c0-2.08-1.669-3.773-3.72-3.773H5.452Zm7.198 16.57H5.452c-2.986 0-5.415-2.465-5.415-5.494V6.04c0-3.03 2.429-5.494 5.415-5.494h7.198c2.986 0 5.416 2.464 5.416 5.494v7.303c0 3.03-2.43 5.494-5.416 5.494",
    fill: "#5D5BEA"
  })));
};
export default SvgInstagramColored;